<template>
  <div class="insights-integrations-tabs">
    <div class="tab">
      <div
        class="img mr-10"
        :style="githubStyle"
        :alt="gitHubIntegrationLogo.alt"
      />
      <span>GitHub</span>
    </div>
  </div>
</template>

<script>
import { INSIGHTS_ASSETS as INSIGHTS } from '~/app_constants';

export default {
  data: () => ({
    gitHubIntegrationLogo: INSIGHTS.github_integration_logo,
    githubStyle: {
      backgroundImage: `url("${INSIGHTS.github_integration_logo_white.src}")`,
    },
  }),
};
</script>
